module.exports = __webpack_public_path__ + "static/media/logo-igarapegrande.c2c03d06.png";